import { modifier } from 'ember-modifier';
import { assert } from '@ember/debug';

interface HighlightSignature {
  Element: HTMLSpanElement;
  Args: {
    Positional: [term?: string];
  };
}

export default modifier<HighlightSignature>(function highlight(element, [term]) {
  if (!term) {
    return;
  }

  assert(
    'Element should not contain any child components.',
    Array.from(element.children).filter((el) => el.tagName !== 'MARK').length === 0,
  );

  const text = element.innerHTML;

  const regex = new RegExp(`(${term})`, 'gi');
  const highlighted = text.replace(regex, '<mark>$1</mark>');
  element.innerHTML = highlighted;
});
